import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({ className = '', name, fontSize = '24px', iconStyle = 'outlined' }) => (
  <i
    className={`material-icons${iconStyle ? `-${iconStyle}` : ''} overflow-hidden ${className}`}
    style={{
      fontSize,
      height: fontSize,
      width: fontSize
    }}
  >
    {name}
  </i>
)

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  fontSize: PropTypes.string,
  iconStyle: PropTypes.string
}
export default Icon
